module.exports = __webpack_public_path__ + "img/flag-NETHERLANDS.7a3fccae.svg";